import React from 'react';
export const MetricsTestimonialsSection = () => {
  const metrics = [{
    value: '+500',
    label: 'páginas de contenido bilingüe'
  }, {
    value: '9',
    label: 'Módulos y Bonos incluidos'
  }, {
    value: '3',
    label: 'niveles (Starters, KET, PET)'
  }, {
    value: '4,9/5',
    label: 'calificación ⭐'
  }];
  return <section className="bg-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-137">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-138">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8" data-id="element-139">
          {metrics.map((m, i) => <div key={i} className="text-center bg-familia-card/40 md:bg-transparent rounded-xl p-4 md:p-0" data-id="element-140">
              <div className="text-3xl sm:text-5xl md:text-6xl font-display font-bold mb-1 md:mb-2 text-familia-cyan" data-id="element-141">
                {m.value}
              </div>
              <div className="text-[13px] sm:text-base text-white/85 font-medium leading-tight" data-id="element-142">
                {m.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};